import { ProjectAssetModel } from 'api/models';
import { ProjectAssets } from 'modules/shared/constants/project-assets';

export const getProjectFirstAsset = (assets: ProjectAssetModel[]) => {
    const assetMap = assets.reduce((acc, cur) => {
        acc[cur.name] = true;

        return acc;
    }, {} as { [key: string]: boolean });

    return ProjectAssets.find((row) => assetMap[row.identifier]);
};
